module.exports = __webpack_public_path__ + "img/kf.3d76ac96.png";